import useUuid from '../../../hooks/uuid-hook';
import FontBody2 from '../../fonts/font-body2/font-body2';
import {FONT_COLOR} from '../../fonts/font-props';
import './toggle.scss';

export enum LABEL_POSITIONS {
    LEFT = 'left',
    RIGHT = 'rigth',
}

export interface IToggleProps {
    label: string;
    labelPosition?: LABEL_POSITIONS;
    checked?: boolean;
    onChange?(checked: boolean): void;
    disabled?: boolean;
}

export const Toggle: React.FC<IToggleProps> = ({
                                                   label,
                                                   labelPosition = LABEL_POSITIONS.RIGHT,
                                                   checked,
                                                   onChange = () => { },
                                                   disabled = false,
                                               }) => {
    const elemId = useUuid();

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!disabled && onChange) {
            onChange(e.target.checked);
        }
    }

    return (
        <div className={`toggle-block${disabled ? ' disabled' : ''} ${labelPosition}`}>
            <input type="checkbox" id={elemId}
                   checked={checked ?? false} onChange={handleChange}/>
            <label htmlFor={elemId}>
                {labelPosition === LABEL_POSITIONS.LEFT && <FontBody2 color={FONT_COLOR.PRIMARY2}>{label}</FontBody2>}
                <span className="toggle"></span>
                {labelPosition === LABEL_POSITIONS.RIGHT && <FontBody2 color={FONT_COLOR.PRIMARY2}>{label}</FontBody2>}
            </label>
        </div>
    );
}
